module.exports = __webpack_public_path__ + "static/media/search-inverted.9085c205.svg";